import React from 'react';

import Jakob from '../../../src/images/contacts/jakob.jpeg';
import Nikolaj from '../../../src/images/contacts/nikolaj.png';
import Erik from '../../../src/images/contacts/erik.png';
import Nicklas from '../../../src/images/contacts/nicklas.png';

import './index.sass';


const Members = () => {

  return (
    <div className="members">

      <h2>Medarbejdere</h2>

      <div className="row">
        <div className="members__member-card col-12 col-md-6">
          <div className="members__member-img-wrapper">
            <img alt="Jakob"
                 className="members__member-img lazyload"
                 data-expand="100"
                 data-sizes="auto"
                 data-src={Jakob}
            />
            <div className="members__member-name-wrapper">
              <div className="members__member-name">
                Jakob Dalhoff
              </div>
              <div className="members__member-position">
                CEO
              </div>
            </div>
          </div>
          <div className="members__member-info">
            Jakob har læst Cand.merc. Finansiering og Regnskab og er direktør og stifter af Selskabslokaler.dk. Jakob har ansvaret for den daglige drift og ledelse. Læs mere om Jakob Dalhoff.
          </div>
        </div>

        <div className="members__member-card col-12 col-md-6">
          <div className="members__member-img-wrapper">
            <img alt="Nicklas"
                 className="members__member-img lazyload"
                 data-expand="100"
                 data-sizes="auto"
                 data-src={Nicklas}
            />
            <div className="members__member-name-wrapper">
              <div className="members__member-name">
                Nicklas
              </div>
              <div className="members__member-position">
                PROJECT COORDINATOR
              </div>
            </div>
          </div>
          <div className="members__member-info">
            Nicklas studerer Cand.merc. Erhvervsøkonomi ved Copenhagen Business School. Han hjælper primært med kundesupport, projektkoordinering og sociale medier.
          </div>
        </div>

        <div className="members__member-card col-12 col-md-6">
          <div className="members__member-img-wrapper">
            <img alt="Erik"
                 className="members__member-img lazyload"
                 data-expand="100"
                 data-sizes="auto"
                 data-src={Erik}
            />
            <div className="members__member-name-wrapper">
              <div className="members__member-name">
                Erik
              </div>
              <div className="members__member-position">
                PROJECT COORDINATOR
              </div>
            </div>
          </div>
          <div className="members__member-info">
            Erik studerer HA i projektledelse ved Copenhagen Business School. Han hjælper med kundesupport og projektkoordinering. Erik har været ansat siden August 2023.
          </div>
        </div>

        <div className="members__member-card col-12 col-md-6">
          <div className="members__member-img-wrapper">
            <img alt="Nikolaj"
                 className="members__member-img lazyload"
                 data-expand="100"
                 data-sizes="auto"
                 data-src={Nikolaj}
            />
            <div className="members__member-name-wrapper">
              <div className="members__member-name">
                Nikolaj
              </div>
              <div className="members__member-position">
                PROJECT COORDINATOR
              </div>
            </div>
          </div>
          <div className="members__member-info">
            Nikolaj studerer HA i Europæisk Business ved Copenhagen Business School. Han hjælper primært med kundesupport og projektkoordinering. Nikolaj har været ansat siden August 2022.
          </div>
        </div>
      </div>

    </div>
  )
}

export default Members;
